module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kTj3f"))).then(() => parcelRequire('d0iPb'));